import { render, staticRenderFns } from "./LiveNotice.vue?vue&type=template&id=0868983e&scoped=true"
import script from "./LiveNotice.vue?vue&type=script&lang=js"
export * from "./LiveNotice.vue?vue&type=script&lang=js"
import style0 from "./LiveNotice.vue?vue&type=style&index=0&id=0868983e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868983e",
  null
  
)

export default component.exports